(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_announcement"] && !Shopify.designMode) return;
  try {
    if (!window.announcementKlaviyoListenerAdded) {
    window.announcementKlaviyoListenerAdded = true;

    document.addEventListener('click', function (event) {
      const trigger = event.target.closest(
        '.announcement-bar__klaviyo-trigger[data-klaviyo-form-id]'
      );

      if (!trigger) return;

      event.preventDefault();

      const formId = trigger.dataset.klaviyoFormId;

      if (!formId) return;

      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', formId]);
    });
  }
  } catch(e) { console.error(e); }
})();

})();
